module.exports = require("supports-color");


//////////////////
// WEBPACK FOOTER
// external "supports-color"
// module id = 185
// module chunks = 0 1